import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const inputDescriptionFn = /* @__PURE__ */ createRecipe('input-description', {}, [])

const inputDescriptionVariantMap = {}

const inputDescriptionVariantKeys = Object.keys(inputDescriptionVariantMap)

export const inputDescription = /* @__PURE__ */ Object.assign(memo(inputDescriptionFn.recipeFn), {
  __recipe__: true,
  __name__: 'inputDescription',
  __getCompoundVariantCss__: inputDescriptionFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: inputDescriptionVariantKeys,
  variantMap: inputDescriptionVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, inputDescriptionVariantKeys)
  },
  getVariantProps: inputDescriptionFn.getVariantProps,
})